export const CHATGROUPS_SELECTOR_KEY = 'chatgroups';
export const CHATGROUPS_SELECTOR_KEY_BY_ID = 'chatgroups/chatgroup';
export const MY_NETWORKING_CHATGROUPTYPE_ID = 3;
export const CHATGROUP_COMMENT = 'Chatgroupcomment';
